import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { firstValueFrom } from "rxjs";
import { ContactInformation } from "../../models/masters/contact-information.interface";
import { LoadingService } from "../loading.service";

@Injectable({
    providedIn: "root"
})
export class CustomerService {

    constructor(private api: ApiService,
        private loadingService: LoadingService
    ) {
    }

    async getCustomerContacts(customerId: string): Promise<ContactInformation[]> {
        this.loadingService.show();
        try {
            const response = await firstValueFrom(this.api.getCustomerContacts(customerId));   
            return response.data;
        } catch(error) {
            console.log("Failed to fetch contacts: ", error);
            throw error;
        } finally {
            this.loadingService.hide();
        }
    }
}